import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {PipesModule} from '../pipes/pipes.module';
import {Angulartics2Module} from 'angulartics2';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    Angulartics2Module,
    TranslateModule,
  ]
})
export class SharedModule {
}
